import Privacy from "../Privacy";

function CSAE() {
    return (
        <Privacy>
            <div className="w-full text-[#475467] ">
                <h1 className="text-[28px] text-black pt-4 font-bold ">
                    Child Sexual Abuse and Exploitation (CSAE) Policy
                </h1>
                <p className=" pt-4" id="OUR SERVICES">
                    <span className="font-semibold "> Effective Date:</span> June 5th, 2025
                </p>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        1. Purpose
                    </h1>
                    <p>
                        <span className="font-bold">Arad</span> (“we,” “us,” or “our”) is committed to providing a safe and secure platform for all users, especially children and vulnerable individuals. This Child Sexual Abuse and Exploitation (CSAE) Policy sets forth our zero-tolerance approach toward any content, behavior, or activity involving child sexual abuse or exploitation on the Arad platform (“App”). Our goal is to prevent the sharing, promotion, or facilitation of any CSAE material, ensure swift removal of such content, and comply with all applicable laws protecting children.
                    </p>
                </div>

                <div className="my-6">

                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        2. Scope
                    </h1>
                    <p>
                        This Policy applies to all users of Arad, including but not limited to individuals posting incidents, events, updates, and alerts. It covers all content types, including text, images, videos, audio, links, and user interactions.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        3. Prohibited Conduct and Content
                    </h1>
                    <p>
                        Users are strictly prohibited from:
                    </p>
                    <ul className="list-disc ml-10">
                        <li className="py-2">Posting, sharing, distributing, or soliciting any material depicting child sexual abuse or exploitation, including any visual or written content.</li>
                        <li className="py-2">Using the App to facilitate or promote any form of child exploitation, trafficking, or abuse.</li>
                        <li className="py-2">Engaging in grooming, coercion, solicitation, or communication with minors for sexual purposes.</li>
                        <li className="py-2">Sharing links or references to CSAE materials or illegal websites.</li>
                        <li className="py-2">Attempting to circumvent content filters or moderation tools designed to detect and block CSAE material.</li>
                    </ul>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        4. Content Moderation and Reporting
                    </h1>
                    <ul className="list-disc ml-10">
                        <li className="py-2"><span className="font-bold">Automated Detection:</span> Arad employs advanced automated technologies (such as AI-based image and text scanning) to detect and block content that may violate this Policy.</li>
                        <li className="py-2"><span className="font-bold">Human Review:</span> Content flagged by automated systems or reported by users will be promptly reviewed by trained moderators.</li>
                        <li className="py-2"><span className="font-bold">User Reporting:</span> Users can report suspected CSAE content or behavior through dedicated in-app reporting tools. All reports are treated confidentially and investigated swiftly.</li>
                        <li className="py-2"><span className="font-bold">Immediate Removal:</span> Confirmed CSAE content will be removed immediately. Accounts associated with such content will be suspended or permanently banned.</li>
                        <li className="py-2"><span className="font-bold">Collaboration with Authorities:</span> We cooperate fully with law enforcement, child protection agencies, and relevant authorities by providing necessary information and support in investigations.</li>
                    </ul>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        5. Legal Compliance
                    </h1>
                    <p>
                        Arad complies with all applicable international, federal, state, and local laws regarding child protection, including but not limited to:
                    </p>

                    <ul className="list-disc ml-10">
                        <li className="py-2">The <span className="font-bold">U.S. PROTECT Act</span></li>
                        <li className="py-2">The <span className="font-bold">Children’s Online Privacy Protection Act (COPPA)</span></li>
                        <li className="py-2">The <span className="font-bold">UN Convention on the Rights of the Child (UNCRC)</span></li>
                        <li className="py-2">The <span className="font-bold">Nigeria Child Rights Act</span> and relevant local laws</li>
                        <li className="py-2">Other international protocols aimed at combating CSAE</li>
                    </ul>
                    <p>Users found to be violating these laws through activities on the App may be subject to criminal prosecution.</p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        6. User Obligations
                    </h1>
                    <p>
                        By using Arad, users agree to:
                    </p>
                    <ul className="list-disc ml-10">
                        <li className="py-2">Abstain from posting or sharing any content that violates this Policy.</li>
                        <li className="py-2">Report any suspected CSAE content or behavior immediately.</li>
                        <li className="py-2">Cooperate with any investigations initiated by Arad or law enforcement.</li>
                        <li>Ensure that any incident reports or updates shared do not inadvertently expose victims or involve illegal content.</li>
                    </ul>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        7. Privacy and Confidentiality
                    </h1>
                    <p className="mb-4">
                        Arad treats reports and investigations related to CSAE with the highest degree of confidentiality. Personal information related to victims or reporters will only be shared with authorized law enforcement or child protection agencies as required by law.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        8. Education and Awareness
                    </h1>
                    <p className="mb-4">
                        Arad is committed to promoting awareness and education regarding CSAE prevention. We provide resources and links to recognized child protection organizations within the App to support users in understanding and identifying risks.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        9. Consequences of Policy Violations
                    </h1>
                    <p className="mb-4">
                        Violations of this Policy will result in:
                    </p>
                    <ul className="list-disc ml-10">
                        <li className="py-2">Immediate removal of offending content.</li>
                        <li className="py-2">Suspension or termination of user accounts.</li>
                        <li className="py-2">Reporting to law enforcement and child protection agencies.</li>
                        <li>Legal action where appropriate.</li>
                    </ul>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        10. Policy Updates
                    </h1>
                    <p className="mb-4">
                        Arad reserves the right to amend or update this Policy at any time to reflect changes in legal requirements, industry standards, or operational needs. Users will be notified of material changes via in-App announcements or email communications.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        11. Contact and Reporting
                    </h1>
                    <p>
                        If you become aware of any child sexual abuse or exploitation content or behavior on Arad, please report immediately through the in-App reporting tool or contact us directly at:
                    </p>
                    <p className="pb-1">
                        <span className="font-bold">Email:</span> abuse@myaradugbo.com
                    </p>
                    <p className="pb-1">
                        <span className="font-bold">Phone:</span> (908) 900-1277
                    </p>
                </div>

            </div>
        </Privacy>
    );
}

export default CSAE;